import { CircleLoader } from "../../components/CircleLoader";

export const AssignStaffToClass = ({
  form,
  setForm, // Pass setter to manage the array
  teachers,
  isLoading,
  classData,
  handleSubmit,
}: any) => {
  const handleToggleTeacher = (id: string) => {
    const currentIds = form.teacherId || [];
    if (currentIds.includes(id)) {
      setForm({
        ...form,
        teacherId: currentIds.filter((tid: string) => tid !== id),
      });
    } else {
      setForm({ ...form, teacherId: [...currentIds, id] });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="p-4">
      <div className="mb-6">
        <h4 className="font-bold text-[#012063] mb-1">Classroom</h4>
        <p className="text-lg text-[#0096D1] font-semibold">
          {classData?.name}
        </p>
      </div>

      <div className="studentFormContent">
        <h4 className="font-bold text-[#012063] mb-3">Select Staff Members</h4>

        {/* Scrollable Selection Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 max-h-[400px] overflow-y-auto pr-2 register-scroll">
          {teachers.map((staff: any) => {
            const isSelected = form.teacherId?.includes(staff.id);
            return (
              <div
                key={staff.id}
                onClick={() => handleToggleTeacher(staff.id)}
                className={`flex items-center p-3 rounded-xl border-2 cursor-pointer transition-all duration-200 ${
                  isSelected
                    ? "border-[#0096D1] bg-[#0096D1]/[0.05] shadow-sm"
                    : "border-gray-100 bg-gray-50 hover:border-gray-300"
                }`}
              >
                <div
                  className={`flex items-center p-3 rounded-xl border-2 cursor-pointer transition-all duration-200 transform ${
                    isSelected
                      ? "border-[#0096D1] bg-[#0096D1]/[0.05] scale-[0.98]"
                      : "border-gray-100 bg-gray-50 hover:border-gray-300 hover:scale-[1.01]"
                  }`}
                >
                  {isSelected && (
                    <div className="w-2 h-2 bg-white rounded-full" />
                  )}
                </div>
                <div className="flex flex-col">
                  <span
                    className={`text-sm font-bold ${isSelected ? "text-[#012063]" : "text-gray-600"}`}
                  >
                    {staff.surname} {staff.firstname}
                  </span>
                  <span className="text-[10px] uppercase text-gray-400 font-bold tracking-tight">
                    {staff.role || "Staff"}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="mt-8 flex flex-col items-center">
        <p className="text-xs text-gray-400 mb-4 italic">
          {form.teacherId?.length || 0} teacher(s) selected for this classroom.
        </p>
        <button
          type="submit"
          disabled={isLoading || !form.teacherId?.length}
          className="w-full md:w-1/2 py-3 bg-[#012063] hover:bg-[#0096D1] text-white rounded-xl font-bold transition-all shadow-lg active:scale-95 disabled:opacity-50"
        >
          {isLoading ? (
            <div className="flex items-center justify-center gap-2">
              <CircleLoader /> Saving...
            </div>
          ) : (
            "Update Assignments"
          )}
        </button>
      </div>
    </form>
  );
};
